module.exports = __webpack_public_path__ + "static/media/16UNODC23.28808169.jpg";